import { z } from 'zod';
export const Chat_Block_1_ConfigValidator = z.object({
    reason: z.string().optional()
});
//# sourceMappingURL=chat-block-1.js.map